import { observable, action, flow, computed } from 'mobx';
import { rstr2b64 } from 'utils/md5';
import Util from 'utils';
import Config from 'config/Config';
import { Toast } from 'antd-mobile';
import Stores from 'config/Stores';
import Serv from './QuestionnaireServ';
import { clone, cloneDeep, divide } from 'lodash';
import { toJS } from 'mobx';
class QuestionnaireMod {
  // 身份证号、身份证号是否可编辑
  @observable certNum = '';
  @observable questDetail = {
    subjectDetailDtoList: []
  };
  @observable isLogin = false;
  @observable startTime = 0;
  @observable jumpSubList = {}; //选中的跳题id
  @observable listIndex = '';
  @observable isFill = false;

  study = ''; // 是否是从商学院过来的

  @action
  changeState(obj) {
    Object.keys(obj).forEach((key) => {
      this[key] = obj[key];
    });
  }
  /**
   * 获取问卷详情(带题目)
   */
  queryQuestById = flow(function* ({ questId, userId, showNotTargetPrompt }) {
    let params = {
      questId
    };
    if (userId) {
      params.userId = userId;
    }
    try {
      const { data, resultCode, resultMsg, extFields } = yield Serv.queryQuestById(params);
      if (resultCode + '' === '0' && data) {
        data.subjectDetailDtoList.map((item) => {
          // 1: '单选题',
          // 2: '多选题',
          // 3: '判断题',
          // 4: '填空题',
          // 5: '问答题',
          // 6: '矩阵单选',
          // 7: 'NPS',
          // 8: '排序题',
          if ([1, 2, 7, 8].includes(item.type)) {
            item.questOptionDtoList.map((smItem) => {
              smItem.optionId = item.id;
            });
          }
          if ([6].includes(item.type)) {
            item.questOptionDtoList.map((smItem) => {
              smItem.optionId = smItem.id;
            });
            item.questSubjectOptionDtoList.map((smItem) => {
              // if (smItem.isMatrix == 1) {
              smItem.optionId = smItem.id;
              // }
            });
          }
        });
        this.questDetail = data;
      } else {
        if (resultCode === '100002') {
          return extFields;
        } else if (resultCode === '100003') {
          showNotTargetPrompt();
        } else {
          Toast.info(resultMsg);
          window.history.go(-1);
        }
      }
    } catch (error) {
      console.log(error);
      window.history.go(-1);
    }
  });

  // 校验是否是必填
  checkData = (sign) => {
    const { listParamsArray } = this.props.questionnaireMobx;
    const { data } = listParamsArray || {};
    let hasNoWrite = false;
    for (let i = 0; i < data.length; i++) {
      // 直接提交之后不校验后面的内容是否是必填的
      if ((!!sign && sign < i) || sign == 0) {
        break;
      }
      const res = data[i];
      const { isNeed, questOptionDtoList, title, type, questSubjectOptionDtoList, hideAsk } =
        res || {};
      console.log(hideAsk, 'hideAskhideAskhideAsk');
      if (hideAsk) {
        continue;
      }
      const returnObj =
        Array.isArray(questOptionDtoList) &&
        questOptionDtoList.find((resp) => {
          const { isChecked } = resp || {};
          return !!isChecked;
        });
      let list = [];
      if (type == SORT_QUEST) {
        list =
          Array.isArray(questOptionDtoList) &&
          questOptionDtoList.filter((resp) => {
            const { isChecked } = resp || {};
            return !!isChecked;
          });
      }
      if (type == SORT_QUEST) {
        console.log(
          isNeed,
          'isNeedisNeedisNeedisNeed',
          list.length,
          '44444',
          questOptionDtoList.length
        );
      }
      if (
        ((isNeed && (!returnObj || (returnObj && Object.keys(returnObj).length < 1))) ||
          (isNeed && type == SORT_QUEST && list.length != questOptionDtoList.length)) &&
        type != JUZHENG_QUEST
      ) {
        ToastUtil.show(`请填写,${title}`, 2000);
        hasNoWrite = true;
        break;
      }
      if (type == JUZHENG_QUEST) {
        for (let j = 0; j < questSubjectOptionDtoList.length; j++) {
          const res = questSubjectOptionDtoList[j];
          const { selectOptionIndexes } = res || {};
          console.log(
            !(!!selectOptionIndexes && selectOptionIndexes.length > 0),
            'selectOptionIndexesselectOptionIndexes'
          );
          if (!(!!selectOptionIndexes && selectOptionIndexes.length > 0)) {
            ToastUtil.show(`请填写,${title}`, 2000);
            hasNoWrite = true;
            break;
          }
        }
      }
    }
    return hasNoWrite;
  };

  save = flow(function* () {
    let index = this.listIndex;
    let questDetail = cloneDeep(toJS(this.questDetail));
    let subjectDetailDtoList = cloneDeep(questDetail.subjectDetailDtoList);
    let endTime = Date.now();
    let intervalTime = (endTime - this.startTime) / 1000;
    let params = {
      questId: this.questDetail.id,
      intervalTime,
      questSubjectList: []
    };
    if (index > 0) {
      subjectDetailDtoList = subjectDetailDtoList.splice(0, index + 1);
      console.log(index + 1, subjectDetailDtoList);
    }
    subjectDetailDtoList.map((item) => {
      const {
        isNeed,
        title: titleName,
        questOptionDtoList,
        type,
        questSubjectOptionDtoList,
        ishidden
      } = item || {};
      const title = `请填写,${titleName}`;
      // isNeed
      if (isNeed == 1 && !ishidden) {
        if (type == 9 || type == 5 || type == 4) {
          const { title: titleVal } = questOptionDtoList[0] || {};
          if (!titleVal) {
            Toast.show(title);
            throw new Error(title);
          }
        } else if (type == 6) {
          if (!questSubjectOptionDtoList || !questSubjectOptionDtoList.length) {
            Toast.show(title);
            throw new Error(title);
          }
          const returnList = questSubjectOptionDtoList.findIndex((resp) => {
            const { selectOptionIndexes, title } = resp || {};
            if (selectOptionIndexes && selectOptionIndexes.length) {
              return true;
            }
          });
          if (returnList == -1) {
            Toast.show(title);
            throw new Error(title);
          }
        } else {
          if (!questOptionDtoList || !questOptionDtoList.length) {
            Toast.show(title);
            throw new Error(title);
          }
          // 找出选中项, 如果选中项没有填写内容, 则抛出错误,  没有选中项也抛出错误
          const returnObj = questOptionDtoList.find((resp) => resp.isChecked);
          const isAllPass = questOptionDtoList.every((resp) => {
            const { isChecked, isFill, value = '' } = resp || {};
            // !!isChecked && !isFill (选中了且不用填空)
            // !!isChecked && !!isFill && value !== '' (选中了且要填空且填了)
            // !isChecked && returnObj (没选中当前项了, 但是有选中项, 则返回true)
            return (
              (!!isChecked && !isFill) ||
              (!!isChecked && !!isFill && value !== '') ||
              (!isChecked && returnObj)
            );
          });
          if (!isAllPass) {
            Toast.show(title);
            throw new Error(title);
          }
        }
      }
      if (!item.ishidden) {
        params.questSubjectList.push({
          ...item,
          subjectId: item.id,
          questOptionList:
            item.type == 6
              ? [...item.questOptionDtoList, ...item.questSubjectOptionDtoList]
              : [...item.questOptionDtoList]
        });
      }
    });
    console.log('questSubjectListquestSubjectListquestSubjectList', params);
    try {
      Toast.loading();
      const { data } = yield Serv.querySave(params);
      console.log('data', data);
      this.questDetail = {
        ...this.questDetail,
        ...data
      };
      // if (data.isLuckyDraw == 1) {
      //   window.app.routerGoTo(`/shop/draw?id=${data.luckyDrawId}`);
      //   return;
      // }

      // window.app.routerGoTo(`/shop/draw?id=${birthdayDetail.drawActivityId||''}&isBirthday=1&avatar=${birthdayDetail.avatar}&realName=${birthdayDetail.realName}&userId=${mainObject}`)
      window.app.routerGoTo({
        pathname: '/personal/CompleteView',
        state: {
          study: this.study
        }
      });
    } catch (error) {
      // Toast.hide();
    }
  });
}
const questionnaireMod = new QuestionnaireMod();
export default questionnaireMod;



// WEBPACK FOOTER //
// ./src/pages/Shop/Member/Questionnaire/QuestionnaireMod.js